import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Icon } from './Icon';

/**
 * `aqua`/`aqua-soft` — только для воды (подано / подано частично): вода в
 * системе не зелёная, иначе «подано» читается как «хорошо», а это объём,
 * а не оценка. Брать их под что-то другое нельзя.
 */
export type BadgeTone =
  | 'neutral'
  | 'green'
  | 'sage'
  | 'copper'
  | 'outline'
  | 'aqua'
  | 'aqua-soft';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: LucideIcon;
}

/**
 * Значок — read-only смысл. Медь здесь ритм и контраст, а не статус:
 * значение всегда прочитывается из подписи, а не из цвета.
 */
export function Badge({ children, tone = 'neutral', icon }: BadgeProps) {
  return (
    <span className={`badge badge--${tone}`}>
      {icon ? <Icon icon={icon} size={16} /> : null}
      {children}
    </span>
  );
}
